import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import ReOrderReferencesUI from './reorderreferencesui';


export default class ReOrderReferences extends Plugin {
  static get pluginName() {
    return 'ReOrderReferences';
  }

  static get requires() {
    return [ReOrderReferencesUI];
  }
}
